import { Typography } from '@arkestro/arkestro-design-system';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import { InheritedBusinessUnitAgreementLink } from './inherited-business-unit-agreement-link';
import styles from './inherited-business-unit-field.module.scss';
import type { PriceAgreement } from 'types';

interface InheritedBusinessUnitCaptionProps {
  agreement?: PriceAgreement;
  hasNoAgreement: boolean;
  isAgreementLinked: boolean;
}

/** Names the agreement the business unit comes from, or asks for one; nothing while the agreement loads. */
export const InheritedBusinessUnitCaption = ({ agreement, hasNoAgreement, isAgreementLinked }: InheritedBusinessUnitCaptionProps) => {
  const { t } = useTranslation('common');

  if (hasNoAgreement) {
    return <Typography className={styles.caption}>{t('rfx_drawer.inherited_business_unit_no_agreement_caption')}</Typography>;
  }
  if (!agreement) return null;

  const supplierName = agreement.corporate_division.name;

  return (
    <Typography className={styles.caption}>
      <Trans
        components={{ link: <InheritedBusinessUnitAgreementLink agreementId={agreement.id} linked={isAgreementLinked} /> }}
        i18nKey={supplierName
          ? 'common:rfx_drawer.inherited_business_unit_caption'
          : 'common:rfx_drawer.inherited_business_unit_caption_without_supplier'}
        values={{ agreementName: agreement.name, supplierName: supplierName ?? '' }}
      />
    </Typography>
  );
};
